var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar-nav-icon',{attrs:{"tile":"","aria-label":"Home Button"}},[_c('v-avatar',{attrs:{"tile":""}},[_c('v-img',{attrs:{"contain":"","src":require('@/assets/primar_2k2_icon.png')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }